export default "__VITE_ASSET__CFx_3l3J__"